/**
 * Choose which session a time-anchored deep-link (`?from&to`) should open.
 * Returns the id of the session whose start falls within [from, to] (±60s);
 * otherwise the session whose start is closest to `from`. null when no `from`.
 */
export function pickSessionForRange<T extends { id: string; startedAt: string | Date }>(
  items: T[],
  fromIso: string | null,
  toIso: string | null,
): string | null {
  if (!fromIso) return null
  const from = new Date(fromIso).getTime()
  if (Number.isNaN(from)) return null
  const to = toIso ? new Date(toIso).getTime() : from
  let best: { id: string; dist: number } | null = null
  for (const it of items) {
    const t = new Date(it.startedAt).getTime()
    if (Number.isNaN(t)) continue
    if (t >= from - 60_000 && t <= to + 60_000) return it.id
    const dist = Math.abs(t - from)
    if (!best || dist < best.dist) best = { id: it.id, dist }
  }
  return best?.id ?? null
}
